import React from "react";
import {
  Box,
  Typography,
  Divider,
  Grid2,
  Card,
  CardContent,
} from "@mui/material";
import {
  INDIAN_RUPEE_SIGN,
  RENTLY_HOME_ICON_COLOR,
} from "../../constant/constant";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";

const ReviewStep = ({ registerData }) => {
  const { first_name, last_name, email, contact, plan_details } = registerData;

  return (
    <Box sx={{ textAlign: "center", maxWidth: 900, margin: "0 auto" }}>
      <Typography variant="h5" gutterBottom>
        Review Your Information
      </Typography>

      <Divider sx={{ mb: 4 }} />

      {/* Grid2 Layout for the Review Information */}
      <Grid2 container spacing={3} sx={{ textAlign: "left" }}>
        {/* First row: First Name and Last Name */}
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
          <Typography variant="body1">
            <strong>First Name:</strong> {first_name}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
          <Typography variant="body1">
            <strong>Last Name:</strong> {last_name}
          </Typography>
        </Grid2>

        {/* Second row: Email and Contact */}
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
          <Typography variant="body1">
            <strong>Email:</strong> {email}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
          <Typography variant="body1">
            <strong>Contact:</strong> {contact}
          </Typography>
        </Grid2>

        {/* Third row: Subscription Plan */}
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
          <Typography variant="h6">Subscription Plan:</Typography>

          {/* Plan Details Card */}
          {plan_details && (
            <Card
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: `2px solid ${RENTLY_HOME_ICON_COLOR}`,
                borderRadius: 2,
                boxShadow: 3,
                transition: "transform 0.3s ease-in-out",
                "&:hover": { transform: "scale(1.05)" },
                width: "100%", // Ensure the card takes full width
                marginTop: 3, // Adjust the top margin for spacing
              }}
            >
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  {plan_details.plan_name}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ mt: 1 }}
                >
                  {plan_details.plan_description}
                </Typography>
                <Typography variant="h6" sx={{ mt: 4 }}>
                  {`${INDIAN_RUPEE_SIGN} ${plan_details.plan_price}/mo`}
                </Typography>
              </CardContent>

              {/* Right Side: Plan Details */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  p: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <ApartmentIcon sx={{ mr: 1, color: "text.secondary" }} />
                  <Typography variant="body2">{`Add upto ${plan_details.max_buildings} Buildings`}</Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <HomeIcon sx={{ mr: 1, color: "text.secondary" }} />
                  <Typography variant="body2">{`Add upto ${plan_details.max_properties} flats/properties`}</Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <GroupIcon sx={{ mr: 1, color: "text.secondary" }} />
                  <Typography variant="body2">{`Add upto ${plan_details.max_tenants} tenants`}</Typography>
                </Box>
              </Box>
            </Card>
          )}
        </Grid2>
      </Grid2>

      <Divider sx={{ my: 4 }} />

      <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
        Please confirm that the above details are correct before submitting.
      </Typography>
    </Box>
  );
};

export default ReviewStep;
